import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  input,
  OnInit,
  output,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { catchError, of } from 'rxjs';
import { FormatService } from '@/app/common/format/format.service';
import { VideoResponseDto } from '@/app/common/general-types/videos.dto';
import { SuperSocialService } from '@/app/services/super-social/super-social.service';
import { SelectedSocialPostEvent } from '../application-actions/application-actions.types';

interface InstagramSelectionPost {
  post_id?: string;
  title?: string;
  thumbnail_url?: string;
  share_url?: string;
  timestamp?: string;
}

@Component({
  selector: 'ins-creator-select-post-instagram',
  templateUrl: './select-post-instagram.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block' },
})
export class CreatorSelectPostInstagram implements OnInit {
  instagramAccountId = input.required<string>();
  appVid = input.required<VideoResponseDto>();

  selectedPost = output<SelectedSocialPostEvent>();

  readonly latestPosts = signal<InstagramSelectionPost[] | undefined>(undefined);
  readonly loadingState = signal<'idle' | 'loading' | 'loaded' | 'error'>('idle');

  readonly formatService = inject(FormatService);
  private destroyRef = inject(DestroyRef);
  private superSocialService = inject(SuperSocialService);

  ngOnInit(): void {
    this.loadingState.set('loading');
    this.superSocialService
      .getPostsForSelectionInstagram(this.instagramAccountId())
      .pipe(
        catchError(() => {
          this.loadingState.set('error');
          return of({ data: [] as InstagramSelectionPost[] });
        }),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((response) => {
        this.latestPosts.set(response.data ?? []);
        this.loadingState.set('loaded');
      });
  }

  selectPost(post: InstagramSelectionPost): void {
    this.selectedPost.emit({ post, appVid: this.appVid() });
  }

  postTimeLabel(post: InstagramSelectionPost): string {
    if (!post.timestamp) {
      return '';
    }
    return this.formatService.getTimeSinceUpdated(new Date(post.timestamp));
  }
}
